/*
 * SC cart nudge
 * Handles the single nudge button in snippets/cart-drawer.liquid:
 *   "+ Add"   -> quantity + 1 on the same line (keeps its plan)
 *   "Switch"  -> sets quantity and selling plan on the line
 * Replaces sc-cart-upgrade.js.
 */
(() => {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-sc-nudge]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    const key = btn.getAttribute('data-line-key');
    const quantity = parseInt(btn.getAttribute('data-quantity'), 10);
    if (!key || !quantity) return;

    const body = { id: key, quantity: quantity };
    const plan = btn.getAttribute('data-selling-plan');
    if (plan) body.selling_plan = parseInt(plan, 10);

    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Updating';

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error('cart change failed: ' + res.status);

      const sectionRes = await fetch('/?sections=cart-drawer');
      const sectionData = await sectionRes.json();

      if (window.eventBus && typeof window.eventBus.emit === 'function') {
        window.eventBus.emit('update:cart:drawer', { sections: sectionData });
      } else {
        window.location.reload();
      }
    } catch (err) {
      console.error('[SC cart nudge] Error:', err);
      btn.disabled = false;
      btn.textContent = label;
    }
  });
})();
